<template>
  <div class="not-found">
    <h1>404 Not found</h1>
  </div>
</template>
